import * as TechRegisterSelector from './tech-register.selector';

export {TechRegisterSelector as TechRegisterSelectors};
